define.alias("shared/components/shared/plan-recommendation/option-card", "preview-grid/components/shared/plan-recommendation/option-card");